import React from 'react';
import { TabView } from '../TabView';
import ApplicationInfo from './ApplicationInfo';
import BasicFeesDeposits from './BasicFeesDeposits';
import CostsCovered from './CostsCovered';
import LeasingTerms from './LeasingTerms';
import ParkingFees from './ParkingFees';
import PetPolicy from './PetPolicy';

const Leasing = () => {
  return (
    <TabView>
      <BasicFeesDeposits />
      <LeasingTerms />
      <ApplicationInfo />
      <PetPolicy />
      <ParkingFees />
      <CostsCovered />
    </TabView>
  );
};

export default Leasing;
